module.exports = __webpack_public_path__ + "img/vk.com.c69b4d9e.svg";